<template>
  <input
    id="upload-input"
    type="file"
    :multiple="multiple"
    accept="image/*"
    @change="uploadFile"
  />
</template>
<script>
import request from "@/utils/request";
export default {
  name: "upload-file",
  data() {
    return {
      uploadUrl: "//live.b.hxylt.org.cn/api/v2/common/upload",
    };
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async uploadFile(ev) {
      const { files } = ev.target;
      const loadingInstance = this.$loading();
      const promises = [...files].map((file, index) => {
        const formData = new FormData();
        formData.append(`file[${index}]`, file);
        return request({
          headers: {
            "content-type": "multipart/form-data",
          },
          method: "POST",
          url: this.uploadUrl,
          data: formData,
        });
      });

      const results = await Promise.allSettled(promises);
      const successFilters = results.filter(
        ({ status }) => status === "fulfilled"
      );
      const imageList = successFilters.map(({ value }) => {
        const { url = "" } = value.message[0];
        return url;
      });

      loadingInstance.close();
      this.$emit("change", imageList);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
